module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all_app p_background clearfix"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("所有应用")]), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('div', {
    staticClass: "operation_box clearfix"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('section', {
    staticClass: "search_box border_color"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.appName),
      expression: "appName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search_control",
    attrs: {
      "type": "text",
      "placeholder": "输入应用名称"
    },
    domProps: {
      "value": (_vm.appName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getSystemConfigList('1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_search",
    on: {
      "click": function($event) {
        return _vm.getSystemConfigList('1')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table_box clearfix"
  }, [_c('table', {
    staticClass: "table table-hover text-center"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.page.content), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "text-left",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.lookAppCloudDetail(item.id, item.inspectStatus, item.publishStatus, item.saleVersionId, item.versionCount)
        }
      }
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail"
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.appName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.versionNo))]), _vm._v(" "), (item.appStatus == '3') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("禁止销售")]) : (item.inspectStatus == '9') ? _c('td', {
      staticClass: "color_ff1212"
    }, [_vm._v("准备提交")]) : (item.inspectStatus == '0') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("等待审核")]) : (item.inspectStatus == '3') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("正在审核")]) : (item.inspectStatus == '2') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("审核被拒")]) : (item.publishStatus == '0' && item.inspectStatus == '1') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("等待上架")]) : (item.inspectStatus == '1' && item.appStatus == '1' && item.publishStatus == 1) ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("可供销售")]) : (item.appStatus == '2') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("暂停销售")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time")(item.publishTime ? item.publishTime : '')))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(item.inspectStatus == '0') ? _c('i', {
      staticClass: "glyphicon icon_recall",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "撤回"
      },
      on: {
        "click": function($event) {
          return _vm.recall(item.saleVersionId, '9')
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.versionCount <= 1 && (item.appStatus == '1' || item.appStatus == '2') && item.inspectStatus == '1' && item.deployType != '109003') ? _c('i', {
      staticClass: "glyphicon icon_stick",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "更新版本"
      },
      on: {
        "click": function($event) {
          return _vm.updateAppCloud(item.id, item.appversionid, item.versionCount)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.appStatus == '1' && item.publishStatus != '0' && item.inspectStatus == '1') ? _c('i', {
      staticClass: "glyphicon icon_pause",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "暂停销售"
      },
      on: {
        "click": function($event) {
          return _vm.showConfirm1(item.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.saleVersionId == item.appversionid && item.inspectStatus != '3' && item.appStatus != '3') ? _c('i', {
      staticClass: "glyphicon icon_edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          return _vm.editAppCloud(item.id, item.saleVersionId, item.versionCount, item.inspectStatus)
        }
      }
    }) : (item.saleVersionId != item.appversionid && item.inspectStatus != '3') ? _c('i', {
      staticClass: "glyphicon icon_edit",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          return _vm.editAppCloud(item.id, item.saleVersionId, item.versionCount, item.inspectStatus)
        }
      }
    }) : _vm._e(), _vm._v(" "), (((item.appStatus != '1' || item.publishStatus == '0' || item.appStatus == '2') && item.appStatus != '3') && item.inspectStatus == '1') ? _c('i', {
      staticClass: "glyphicon icon_upline",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "上线销售"
      },
      on: {
        "click": function($event) {
          return _vm.deployAppCloud(item.id, item.saleVersionId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.appStatus == '3' && item.inspectStatus != '0' && item.inspectStatus != '0' && item.inspectStatus != '3') ? _c('i', {
      staticClass: "glyphicon icon_relieve",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "申请解禁"
      },
      on: {
        "click": function($event) {
          return _vm.applyApp()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.versionCount <= 1 && item.inspectStatus != '3') ? _c('i', {
      staticClass: "glyphicon icon_del",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.showConfirm(item.id, item.saleVersionId)
        }
      }
    }) : (item.versionCount > 1 && item.saleVersionStatus != '3') ? _c('i', {
      staticClass: "glyphicon icon_del",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.showConfirm(item.id, item.saleVersionId)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.page.totalPages <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publicStatus),
      expression: "publicStatus"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.publicStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publicStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    class: _vm.page.totalPages > 0 ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "row-fluid"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('v-tip', {
    attrs: {
      "trueFlag": _vm.trueFlag,
      "falseFlag": _vm.falseFlag,
      "tipMsg": _vm.tipMsg
    }
  }), _vm._v(" "), (_vm.confirmFlag) ? _c('v-confirm', {
    attrs: {
      "bigMsg": _vm.bigMsg
    },
    on: {
      "confirmOff": function($event) {
        _vm.confirmFlag = !_vm.confirmFlag
      },
      "confirmTrue": _vm.deleteAppVersionCloud
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.confirmFlag1) ? _c('v-confirm', {
    attrs: {
      "bigMsg": _vm.bigMsg1
    },
    on: {
      "confirmOff": function($event) {
        _vm.confirmFlag1 = !_vm.confirmFlag1
      },
      "confirmTrue": _vm.stopAppCloud
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("基本信息")]), _vm._v(" "), _c('th', [_vm._v("版本编号")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("上线时间")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5205f56c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/all_app.vue
// module id = 1259
// module chunks = 1